import * as React from 'react';

import { Reservation, VenueReservationContentItemV2 } from '../../../graphql/API';
import useListReservationContentQuery from '../../../hooks/reactQuery/useListReservationContentQuery';

export const useReservationPosts = (
  reservation?: Reservation | null,
): VenueReservationContentItemV2[] => {
  const offerID = reservation?.offerID ? Number(reservation.offerID) : undefined;

  const { data } = useListReservationContentQuery(
    { offerIDs: offerID ? [offerID] : undefined, isPost: true, byVenue: false },
    50,
    !!offerID,
  );

  return React.useMemo(() => {
    if (!reservation?.id) {
      return [];
    }
    return data.filter((item) => String(item.reservationID) === String(reservation.id));
  }, [data, reservation?.id]);
};
